// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faEye, faExternalLinkAlt, faGlobe, faLink, faDownload, faBook, faArchive, faEnvelope, faPhone, faBriefcase, faUserGraduate, faAddressCard, faPrint } from '@fortawesome/free-solid-svg-icons'
import { faFacebookF, faTwitter, faLinkedinIn, faGithub } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import Scrollspy, { Easing } from 'vue2-scrollspy'

import Default from './layouts/Default.vue'
import Print from './layouts/Print.vue'

import { isUrl } from './utils/utils'

require('bootstrap')

const db = require('./db.json')

// require('bootstrap/dist/css/bootstrap.css')

library.add([faEye, faExternalLinkAlt, faGlobe, faLink, faDownload, faFacebookF, faTwitter, faLinkedinIn, faGithub, faBook, faArchive, faEnvelope, faPhone, faBriefcase, faUserGraduate, faAddressCard, faPrint])

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.component('with-root', {
  functional: true,
  props: ['show'],
  render (h, ctx) {
    const children = ctx.children.filter(vnode => vnode.tag)
    if (children.length !== 1) {
      console.warn('this component accepts only one root node in its slot')
    }
    if (ctx.props.show) {
      return children[0]
    } else {
      return children[0].children
    }
  }
})

Vue.component('default-layout', Default)
Vue.component('print-layout', Print)

Vue.use(Vuex)

Vue.use(Scrollspy, {
  easing: Easing.Cubic.In
})

Vue.config.productionTip = false

const store = new Vuex.Store({
  state: {
    $loading: 0,
    $profile: db.profile,
    $studies: db.studies,
    $works: db.works,
    $projects: db.projects,
    $publications: db.publications,
    $students: db.students,
    $teaching: db.teaching
  },
  getters: {
    getProject: (state) => (id) => {
      return state.$projects.filter(p => p.id === parseInt(id))[0]
    },
    toBase: (state) => (path) => {
      if (isUrl(path)) {
        return path
      }

      return path
        ? (process.env.BASE_URL + '').replace(/\/+$/, '') + '/' + path.replace(/^\/+/, '')
        : undefined
    }
  },
  mutations: {
    increase$loading: function (state) { state.$loading = state.$loading + 1 },
    decrease$loading: function (state) { state.$loading = Math.max(state.$loading - 1, 0) }
  }
})

/* eslint-disable no-new */
new Vue({
  store: store,
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  computed: {
    $loading: function () { return this.$store.state.$loading },
    $profile: function () { return this.$store.state.data.profile },
    $studies: function () { return this.$store.state.data.studies },
    $works: function () { return this.$store.state.data.works },
    $projects: function () { return this.$store.state.data.projects },
    $publications: function () { return this.$store.state.data.publications },
    $students: function () { return this.$store.state.data.students },
    $teaching: function () { return this.$store.state.data.teaching }
  },
  methods: {
    increase$loading: function () { return this.$store.commit('increase$loading') },
    decrease$loading: function () { return this.$store.commit('decrease$loading') },
    getProject: function (id) { return this.$store.getters.getProject(id) },
    toBase: function (path) { return this.$store.getters.toBase(path) }
  }
})



// WEBPACK FOOTER //
// ./src/main.js